import { useCallback, useRef } from 'react';
import { css } from '@emotion/react';
import { AnchorButton } from '@core/components/Button';
import { hasCTA } from '@core/helpers/video/hasCTA';
import { useVisibilityObserver } from '@core/hooks/useVisibilityObserver';
import { useContextTranslation } from '@core/i18n';
import { getCTATranslation } from '@core/i18n/cta/getCTATranslation';
import { useContextParams } from '@core/params/context';
import { usePIPTarget } from '@core/pictureInPicture/usePIPTarget';
import { useStore } from '@core/widgets/store';
import { appContextSelector } from '@core/widgets/store/selectors';
import { useTrackCTAClick } from '@core/widgets/tracking/useTrackCTAClick';
import { useTrackCTAImpression } from '@core/widgets/tracking/useTrackCTAImpression';
/**
 *
 * @param param0
 * @returns
 */
export const CTAButton = ({ video }) => {
    const { t } = useContextTranslation();
    const storeBorderStyle = useStore((state) => state.params?.ui_border_style);
    const trackCTAImpression = useTrackCTAImpression(video);
    const trackCTAClick = useTrackCTAClick(video);
    const ctaImpressionVideoTracked = useRef(null);
    const appContext = useStore(appContextSelector);
    const params = useContextParams();
    const ctaRef = useVisibilityObserver({
        threshold: [0.8],
        onChange: useCallback((isVisible) => {
            if (isVisible && video && video !== ctaImpressionVideoTracked.current) {
                ctaImpressionVideoTracked.current = video;
                trackCTAImpression(appContext);
            }
        }, [trackCTAImpression, video, appContext]),
    });
    const { url, target, onClick: onClickPIP, } = usePIPTarget({ url: video?.action_url || '', params });
    const onCTAButtonClick = useCallback((e) => {
        e.stopPropagation();
        trackCTAClick(appContext);
        onClickPIP(e);
    }, [appContext, onClickPIP, trackCTAClick]);
    if (hasCTA(video)) {
        return (<AnchorButton borderStyle={storeBorderStyle} href={url} target={target} onClick={onCTAButtonClick} ref={ctaRef} ripple css={css `
          --button-border-radius: var(--cta-button-border-radius);
          --button-font-size: var(--cta-button-font-size);
          --button-font-weight: var(--cta-button-font-weight);
          --button-height: var(--cta-button-height);
          --button-padding: var(--cta-button-padding);

          --primary-button-animation: var(--cta-button-animation);
          --primary-button-background: var(
            --cta-button-background,
            var(--button-color)
          );
          --primary-button-border: var(--cta-button-border);
          --primary-button-color: var(
            --cta-button-color,
            var(--button-font-color)
          );
        `}>
        {video.action_type !== 'custom'
                ? getCTATranslation(t, video.action_type)
                : video.action_type_translation}
      </AnchorButton>);
    }
    return null;
};
